import Dropzone from "react-dropzone";
import { Spin, message } from "antd";
import { FiUploadCloud } from "react-icons/fi";
import { useState } from "react";
import { convertApi, UploadApi } from "../helpers/compressUpload";
import { LoadingOutlined } from "@ant-design/icons";

function ThumbnailPicker(props: any) {
  const [isloading, setIsloading] = useState(false);

  const uploadImage = async (val: any) => {
    try {
      setIsloading(true);
      const file = val[0];

      // Check if edition is selected
      if (!props?.edition) {
        message.error("Select Edition first");
        setIsloading(false);
        return;
      }

      let editon = props?.edition;
      let date = props?.date;

      // Handle PDF files
      if (file?.type === "application/pdf") {
        const up: any = await convertApi(file, "thumb", 0, 1, editon, date);
        if (up?.image_url) {
          props?.onChagnge(up?.image_url);
        } else {
          message.error("Upload failed. Please try again.");
        }
      }
      // Handle image files
      else if (file?.type?.startsWith("image/")) {
        const up: any = await UploadApi(file, "thumb", 0, 1, editon, date);
        if (up?.image_url) {
          props?.onChagnge(up?.image_url);
        } else {
          message.error("Upload failed. Please try again.");
        }
      }
      // Unsupported file type
      else {
        message.error("Please upload a PDF or image file (JPG, PNG, etc.)");
      }

      setIsloading(false);
    } catch (error) {
      console.log(error);
      setIsloading(false);
      message.error("File upload failed. Please try again.");
    }
  };

  return (
    <Dropzone onDrop={uploadImage}>
      {({ getRootProps, getInputProps }) => (
        <section className="Epaper-ThumbnailPicker">
          <div className="Epaper-ThumbnailPickerBox">
            {isloading ? (
              <Spin
                indicator={<LoadingOutlined style={{ fontSize: 20 }} spin />}
              />
            ) : null}
          </div>
          <div
            {...getRootProps({
              className: `ImagePicker-backgroud2 ${props?.size ? "small" : ""}`,
            })}
          >
            <input {...getInputProps()} />
            {props.fileURL ? (
              <img src={props.fileURL} className="Epaper-ThumbnailImage" />
            ) : (
              <div className="Epaper-PagesListBox">
                {isloading ? (
                  <div>Loading . . .</div>
                ) : (
                  <FiUploadCloud size={30} />
                )}
                <div>Upload Thumbnail</div>
              </div>
            )}
          </div>
        </section>
      )}
    </Dropzone>
  );
}

export default ThumbnailPicker;
